import { render, staticRenderFns } from "./AnalisaKasusForm.vue?vue&type=template&id=fb777cc6&scoped=true"
import script from "./AnalisaKasusForm.vue?vue&type=script&lang=js"
export * from "./AnalisaKasusForm.vue?vue&type=script&lang=js"
import style0 from "./AnalisaKasusForm.vue?vue&type=style&index=0&id=fb777cc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb777cc6",
  null
  
)

export default component.exports